var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circular-loader m-3"},[_c('div',{staticClass:"cloader"})])
}]

export { render, staticRenderFns }